import get from 'lodash.get';
import React, { useContext, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';

import apiUtil from 'src/api/userManagement';
import { AppContext } from 'src/containers/Core/AppContext';
import { AppState, setUser } from 'src/containers/Core/AppReducer';
import { BUSINESS_ONBOARDING, SIGN_IN, SIGN_UP } from 'src/containers/Core/Paths';
import EmailVerification from 'src/containers/UserManagement/EmailVerification';

const VerifyEmail: React.FC<RouteComponentProps<{}, {}, { email?: string }>> = ({ history, location: { state } }) => {
  const SUCCESS_MSG = `You have successfully created your account. Please sign in to continue.`;
  const [isSuccess, setIsSuccess] = useState(false);

  const { store, dispatch } = useContext(AppContext);
  const { user }: AppState = store;

  const resendCode = async (email: string) => {
    try {
      await apiUtil.resendEmailVerificationCode(email, 'new-user');
    } catch (error) {
      throw error;
    }
  };
  const verifyCode = async (otp: string, email: string) => {
    try {
      await apiUtil.verifyEmailVerificationCode(otp, email, 'new-user');
      setIsSuccess(true);
      if (user) {
        dispatch(setUser({ ...user, isVerified: true }));
        history.replace(BUSINESS_ONBOARDING);
      }
    } catch (error) {
      throw error;
    }
  };

  if (!get(state, 'email')) {
    history.replace(SIGN_UP);

    return null;
  }

  if (isSuccess) {
    return <SignupSuccessInfo message={SUCCESS_MSG} />;
  }

  return <EmailVerification email={get(state, 'email')} resendCallback={resendCode} verifyCallback={verifyCode} />;
};

export default VerifyEmail;

const SignupSuccessInfo: React.FunctionComponent<{ message: string }> = ({ message }) => (
  <>
    <h4>Thank you,</h4>
    <p>{message}</p>
    <p className={`mt-3`}>
      Back to
      <Link to={SIGN_IN} className={`ml-1 font-weight-bold text-decoration-none`}>
        Sign In
      </Link>
    </p>
  </>
);
